import {
  CLOSED_STATUS,
  DRAFT_STATUS,
  RECUSED_STATUS,
  PUBLISHED_STATUS,
  PENDING_APPROVAL_STATUS,
  PENDING_PUBLISHED_STATUS,
  PUBLISHED_SCREEN,
  REGIME
} from 'src/components/NewsModule/constants'
import { TagVariant } from '../ColoredTag/styles'

export const getTagDatabyNewsCareerStatus = (
  status: string
): { text: string; theme: TagVariant } => {
  switch (status) {
    case DRAFT_STATUS:
      return { text: 'RASCUNHO', theme: 'gray' }
    case RECUSED_STATUS:
      return { text: 'RECUSADA', theme: 'gray' }
    case CLOSED_STATUS:
      return { text: 'ENCERRADA', theme: 'gray' }
    case PUBLISHED_STATUS:
      return { text: 'PUBLICADA', theme: 'green' }
    case PENDING_APPROVAL_STATUS:
      return { text: 'PENDENTE DE APROVAÇÃO', theme: 'yellow' }
    case PENDING_PUBLISHED_STATUS:
      return { text: 'PENDENTE DE PUBLICAÇÃO', theme: 'blue' }
    default:
      return { text: '', theme: 'gray' }
  }
}

export const getNormalizedRegimeString = (regime: string): string => {
  return regime
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

export const getTagVariantByRegime = (regime: string): TagVariant => {
  switch (regime) {
    case REGIME.CLT:
      return 'blue'
    case REGIME.INTERN:
      return 'purple'
    case REGIME.SCHOLARSHIP:
      return 'green'
    default:
      return 'gray'
  }
}
